export enum SortOrder {
  ASCENDING,
  DESCENDING,
}
